import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../apiAccess/PromiseStateContainer';
import BASE_URL from '../apiAccess/urls';
import { addIndentToNip, createNutrientRows } from '../util/util';
import ComponentsTable from './ComponentsTable';

class NIP extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    this.props.setCsvHeader([
      {label: 'Nutrient', key: 'nutrient'},
      {label: 'Unit', key: 'unit'},
      {label: 'Quantity per Serve', key: 'qps'},
      {label: '%DI per Serve', key: 'rdi'},
      {label: 'Quantity per 100 g', key: 'qpg'},
    ]);
  }

  render() {
    const { unitFetch, componentSetFetch, nipFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([unitFetch, componentSetFetch, nipFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([units, componentSet, nip]) {
    const nipComponents = addIndentToNip(componentSet);
    const tableData = createNutrientRows(nipComponents, nip, units);

    return (
      <ComponentsTable
        tableData={tableData}
        setCsvData={this.props.setCsvData}
      />
    );
  }
}

NIP.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  componentSetFetch: PropTypes.instanceOf(PromiseState),
  nipFetch: PropTypes.instanceOf(PromiseState),
  recordid: PropTypes.string.isRequired,
  servingSize: PropTypes.number,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

export default connect(props => {
  let query = typeof props.servingSize === 'number' ? `?amount=${props.servingSize}&` : '?';
  return {
    unitFetch: `${BASE_URL}/unit`,
    componentSetFetch: `${BASE_URL}/component/set/1`,
    nipFetch: `${BASE_URL}/fiav/food/${props.recordid}${query}comp_group_id=1`,
  };
})(NIP);



// WEBPACK FOOTER //
// ./src/components/foodDetail/NIP.js